import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyBankAccount from "./component";
import { withRouter } from "react-router-dom";
import { diyPaymentApprovalProcess, setActiveTab } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        postTokenDocuments
    }
}) => ({
    inspectionResponse,
    postTokenDocuments
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    diyPaymentApprovalProcessConnect: diyPaymentApprovalProcess,
    setActiveTabConnect: setActiveTab
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyBankAccount));
